import { Tabs, TabsProps } from 'antd';
import { TabsPosition } from 'antd/es/tabs';
import Container from 'common/components/container.component';
import TitlePage from 'common/components/title-page.component';
import { DeviceTypeList } from 'config/constants/global.constants';
import { RouteName } from 'config/constants/route.constants';
import { AddressTranscription, UserTranscription } from 'config/constants/transcription.constant';
import { useDeviceType } from 'config/hooks/useDeviceType.hook';
import NavigationUtils from 'config/utils/navigation.util';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { StoreUser } from 'store/models/user.model';
import AddressList from 'user/components/address/address-list.component';
import ProfileInfo from 'user/components/profile/profile-info.component';

type MyProfileContainerProps = {
  user: StoreUser;
};

const MyProfileContainer: React.FC<MyProfileContainerProps> = ({ user }) => {
  const query = NavigationUtils.handleQuery();
  const navigate = useNavigate();
  const userAddress = user.userProfile.address || [];
  const deviceType = useDeviceType();
  const [tabsPosition, setTabsPosition] = useState<TabsPosition>('left');

  const handleTabParams = (paramName: string): string => query.get(paramName) || NavigationUtils.AddressUrlTab.MY_INFO;

  const items: TabsProps['items'] = useMemo(
    () => [
      {
        key: NavigationUtils.AddressUrlTab.MY_INFO,
        label: UserTranscription.USER_MY_INFO,
        children: <ProfileInfo user={user} />,
      },
      {
        key: NavigationUtils.AddressUrlTab.MY_ADDRESS,
        label: AddressTranscription.MY_ADDRESSES,
        children: <AddressList addressData={userAddress} />,
      },
    ],
    [user, userAddress],
  );

  const onChange = (key: string): void => {
    navigate(`${RouteName.MY_PROFILE}?tab=${key}`, NavigationUtils.navigateOptions);
  };

  useEffect(() => {
    setTabsPosition(deviceType === DeviceTypeList.DESKTOP ? 'left' : 'top');
  }, [deviceType]);

  return (
    <Container>
      <TitlePage text={UserTranscription.USER_MY_PROFILE} withLine />
      <Tabs
        defaultActiveKey={handleTabParams('tab')}
        activeKey={handleTabParams('tab')}
        items={items}
        onChange={onChange}
        tabPosition={tabsPosition}
      />
    </Container>
  );
};

export default MyProfileContainer;
